/**
 * 应用路由配置
 */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import InviteAccept from './pages/InviteAccept';  // 邀请链接处理页面
import LocalLogin from './pages/LocalLogin';      // 测试环境本地账号登录页

function AppRouter() {
  return (
    <Routes>
      {/* 根路径重定向到项目管理（独立宣传首页已移除，统一走 shouqian SSO） */}
      <Route path="/" element={<Navigate to="/projects" replace />} />

      {/* 邀请链接处理 */}
      <Route path="/invite" element={<InviteAccept />} />

      {/* 测试环境本地登录（非 SSO 域名时使用） */}
      <Route path="/login" element={<LocalLogin />} />

      {/* 项目管理列表 */}
      <Route path="/projects" element={<App initialView="project-management" />} />

      {/* 新建标书向导 */}
      <Route path="/create" element={<App initialView="new-project" />} />

      {/* 项目编辑页 - 支持 URL 直接访问 */}
      <Route path="/project/:projectId" element={<App initialView="new-project" />} />

      {/* 模板管理及详情 */}
      <Route path="/templates" element={<App initialView="template-management" />} />
      <Route path="/templates/:id" element={<App initialView="template-management" />} />

      {/* 主体管理及详情 */}
      <Route path="/companies" element={<App initialView="company-management" />} />
      <Route path="/companies/:id" element={<App initialView="company-management" />} />
      <Route path="/companies/new" element={<App initialView="company-edit" />} />
      <Route path="/companies/:id/edit" element={<App initialView="company-edit" />} />

      {/* 资源管理及详情 */}
      <Route path="/resources" element={<App initialView="resource-management" />} />
      <Route path="/resources/:id" element={<App initialView="resource-management" />} />

      {/* 项目组管理 */}
      <Route path="/project-groups" element={<App initialView="project-group-management" />} />
    </Routes>
  );
}

export default AppRouter;
